module.exports = __webpack_public_path__ + "img/family-history.8c818a41.svg";